export default "__VITE_ASSET__Bwd2InaD__"